{
  "name": "memories",
  "main": "./index.tsx",
  "version": "1.0.219",
  "scripts": {
    "local": "npm run set-version && cross-env APP_VARIANT=development cross-env ENV_VAR=LOCAL cross-env EXPO_NO_DOTENV=1 expo start --web --port 8081 -c",
    "test": "npm run test:fast",
    "test:fast": "jest --config jest.config.fast.js",
    "test:unit": "jest --config jest.config.fast.js",
    "test:expo": "jest --config jest.config.expo.js",
    "test:server": "cross-env APP_VARIANT=development cross-env ENV_VAR=TEST cross-env EXPO_NO_DOTENV=1 expo start --web --port 8082",
    "set-version": "node ../scripts/sync-frontend-version.js",
    "postversion": "node ../scripts/sync-frontend-version.js",
    "reset-project": "node ./scripts/reset-project.js",
    "android": "expo run:android",
    "ios": "expo run:ios",
    "lint": "expo lint",
    "generate-about": "node ./scripts/generate-about.js",
    "build": "npm run set-version && npm run generate-about && cross-env APP_VARIANT=production cross-env ENV_VAR=DEV cross-env EXPO_NO_DOTENV=1 expo export --platform all --source-maps ",
    "build-maps": "expo export --platform android --source-maps  --clear",
    "build-web": "npm run set-version && npm run generate-about && cross-env APP_VARIANT=production cross-env ENV_VAR=DEV cross-env EXPO_NO_DOTENV=1 expo export --platform web --source-maps",
    "build-android": "npm run set-version && cross-env APP_VARIANT=production cross-env ENV_VAR=DEV cross-env EXPO_NO_DOTENV=1 expo prebuild --platform android && cd android && ./gradlew assembleRelease --build-cache && cd ..",
    "build-android2": "npx expo run:android --variant release --no-install",
    "deploy": "firebase deploy --only hosting --debug --force",
    "prettier-format": "prettier --write **/*.{ts,tsx,js,jsx,html,json,yml,yaml}"
  },
  "dependencies": {
    "@babel/plugin-proposal-class-properties": "^7.18.6",
    "@babel/plugin-proposal-private-methods": "^7.18.6",
    "@expo/vector-icons": "^15.0.3",
    "@react-native-async-storage/async-storage": "2.2.0",
    "@react-native-google-signin/google-signin": "^16.1.2",
    "@reduxjs/toolkit": "^2.9.0",
    "@tensorflow-models/mobilenet": "^2.1.1",
    "@tensorflow/tfjs": "^4.22.0",
    "@tiptap/extension-collaboration": "^3.31.3",
    "@tiptap/pm": "^3.31.4",
    "@tiptap/react": "^3.31.4",
    "@tiptap/starter-kit": "^3.31.4",
    "@tiptap/y-tiptap": "^3.0.9",
    "@types/d3": "^7.4.3",
    "common247": "file:../common247",
    "d3": "^7.9.0",
    "dotenv": "^18.0.5",
    "exifr": "^7.1.3",
    "expo": "~57.0.31",
    "expo-application": "~57.0.3",
    "expo-audio": "^57.0.5",
    "expo-blur": "~57.0.3",
    "expo-build-properties": "~57.0.22",
    "expo-constants": "~57.0.19",
    "expo-device": "~57.0.2",
    "expo-file-system": "~57.0.7",
    "expo-font": "~57.0.4",
    "expo-haptics": "~57.0.3",
    "expo-image": "~57.0.5",
    "expo-image-manipulator": "~57.0.20",
    "expo-image-picker": "~57.0.20",
    "expo-linking": "~57.0.12",
    "expo-location": "~57.0.22",
    "expo-print": "^57.0.2",
    "expo-router": "~57.0.25",
    "expo-secure-store": "~57.0.4",
    "expo-share-intent": "^8.0.1",
    "expo-sharing": "~57.0.24",
    "expo-splash-screen": "~57.0.10",
    "expo-status-bar": "~57.0.1",
    "expo-symbols": "~57.0.3",
    "expo-system-ui": "~57.0.4",
    "expo-web-browser": "~57.0.3",
    "firebase": "^12.2.1",
    "html2canvas": "^1.4.1",
    "isomorphic-webcrypto": "file:./shims/isomorphic-webcrypto",
    "nativewind": "^4.2.4",
    "postcss": "^8.5.28",
    "react": "19.2.3",
    "react-dom": "19.2.3",
    "react-native": "0.86.3",
    "react-native-gesture-handler": "~2.32.0",
    "react-native-reanimated": "4.5.1",
    "react-native-safe-area-context": "~5.7.0",
    "react-native-screens": "~4.26.0",
    "react-native-svg": "15.15.4",
    "react-native-web": "^0.21.0",
    "react-native-webview": "13.16.1",
    "react-native-worklets": "0.10.1",
    "react-redux": "^9.2.0",
    "setimmediate": "^1.0.5",
    "tailwindcss": "^4.3.3",
    "y-protocols": "^1.0.7",
    "y-websocket": "^3.1.0",
    "yjs": "^13.6.33"
  },
  "devDependencies": {
    "@babel/core": "^7.26.0",
    "@babel/plugin-transform-classes": "^8.0.5",
    "@react-native-community/cli": "latest",
    "@types/jest": "29.5.14",
    "@types/react": "~19.2.10",
    "babel-plugin-module-resolver": "^5.0.2",
    "babel-preset-expo": "~57.0.0",
    "cross-env": "^10.1.0",
    "eslint": "^10.6.0",
    "eslint-config-expo": "~57.0.2",
    "metro-react-native-babel-preset": "^0.77.0",
    "prettier": "^3.8.3"
  },
  "overrides": {
    "@babel/core": "^7.26.0",
    "@expo/ui": {
      "@babel/core": "^7.26.0"
    },
    "expo-router": {
      "@babel/core": "^7.26.0",
      "@expo/ui": {
        "@babel/core": "^7.26.0"
      }
    }
  },
  "private": true
}
